define( function() {
	return [ "Top", "Right", "Bottom", "Left" ];
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/cssExpand.js
// module id = 259
// module chunks = 0